import { DEFAULT_ASPECT_RATIO } from '../constants/app';

export const fitDimensions = ({
  width = 0,
  height = 0,
  maxWidth,
}: {
  width?: number;
  height?: number;
  maxWidth: number;
}) => {
  // No real dimensions → use 22:15 (DEFAULT)
  if (!width || !height) {
    return {
      width: maxWidth,
      height: maxWidth / DEFAULT_ASPECT_RATIO,
    };
  }

  // Real dimensions available → preserve their aspect ratio
  const aspectRatio = width / height;

  return {
    width: maxWidth,
    height: maxWidth / aspectRatio,
  };
};
